import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { StarRating } from '../ui/StarRating';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-203" data-mp="3mf7pges1bkaz">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-204" data-mp="3r80tt1jlcqmj">
        <SectionTag icon="⭐" data-id="element-205" data-mp="3r9ll8ialztg6">Testimonios reales</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-206" data-mp="fxenz44vs9">
          Entrenadores de toda España ya lo usan.
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-207" data-mp="91e4jf4uljf2">
          <StarRating size={18} data-id="element-208" data-mp="9031xin52hpj" />
          <span className="text-sm text-muted" data-id="element-209" data-mp="e1iioyiaa224">+500 reseñas verificadas</span>
        </div>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-210" data-mp="2au2avxcsgmz2">
        {testimonials.map((t, i) => <m.div key={t.name} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="flex flex-col rounded-2xl border border-gris-claro bg-white p-6 shadow-card" data-id="element-211" data-mp="2fslx7yvao0ry" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-212" data-mp="1eto0pfdzraor">
              <StarRating size={14} data-id="element-213" data-mp="1erb9scq99pzk" />
              <span aria-hidden="true" data-id="element-214" data-mp="2bjn999u5697c">🇪🇸</span>
            </div>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-gris-oscuro" data-id="element-215" data-mp="26kaocumtzc7e">"{t.text}"</p>
            <div className="mt-4 border-t border-gris-claro pt-3" data-id="element-216" data-mp="26ihgxd4e8nyc">
              <p className="text-sm font-semibold text-azul-dark" data-id="element-217" data-mp="22h5o6yq83mlx">{t.name}</p>
              <p className="text-xs text-muted" data-id="element-218" data-mp="1xikmeuvbouvd">{t.role}</p>
            </div>
          </m.div>)}
      </div>

      <p className="mt-6 text-center text-sm text-muted sm:text-base" data-id="element-219" data-mp="r54ud5ei57zb">
        Más de <span className="font-semibold text-naranja" data-id="element-220" data-mp="m3fgzj3t4i82">9.000 entrenadores</span> en España ya entrenan
        con VOLEY-PRO 360: La Pizarra del Entrenador.
      </p>
    </section>;
}